<template>
  <div>
    <div class="rectangle-wizard-container rectangle-wizard-container--flex" v-if="!isPagingActivated">
      <div v-for="(wizardStep, n) in wizardStepDefinitions" class="rectangle-wizard rectangle-wizard-without-paging" :key="n" >
        <img class="rectangle-wizard-image" :src="require(`@/assets/${wizardStep.imageFileName}`)"/>
        <p class="rectangle-wizard-step-label">{{ $t('common.step') }} {{ n + 1 }}</p>
        <p class="rectangle-wizard-text" v-html="$t(wizardStep.bodyTextPath)"></p>
      </div>
    </div>
    <div v-if="isPagingActivated">
      <div class="rectangle-wizard" v-touch:swipe.left="setNextStep" v-touch:swipe.right="setPreviousStep">
          <img class="rectangle-wizard-image" :src="require(`@/assets/${wizardStepDefinitions[currentStep].imageFileName}`)"/>
          <p class="rectangle-wizard-step-label">{{ $t('common.step') }} {{ currentStep + 1 }}</p>
          <p class="rectangle-wizard-text" v-html="$t(wizardStepDefinitions[currentStep].bodyTextPath)"></p>
      </div>
      <div class="rectangle-wizard-paging">
        <span class="rectangle-wizard-paging-number" :style="{ marginLeft: computePagingMargin() }">
          {{ currentStep + 1 }}
        </span>
        <div v-for="steps in wizardStepDefinitions.length" :key="steps" class="rectangle-wizard-dot"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { Prop, Component, Watch } from 'vue-property-decorator'
import { WizardStepDefinition } from '@/models/wizard-step-definition'
import Vue2TouchEvents from 'vue2-touch-events'

@Component({
  name: 'wizard-display'
})
export default class WizardDisplay extends Vue {
  //#region [Property]
  @Prop({ type: Array, required: true }) public wizardStepDefinitions!: WizardStepDefinition[]
  @Prop({ type: Boolean, required: true }) public isPagingActivated!: boolean
  //#endregion

  //#region [Data]
  public currentStep: number = 0
  //#endregion

  //#region [Computed]
  public computePagingMargin(): string {
    return `${this.currentStep * 25}px`
  }
  //#endregion

  //#region [Methods]
  public setNextStep() {
    if (this.currentStep === this.wizardStepDefinitions.length - 1) {
      this.currentStep = 0
    } else {
      this.currentStep = this.currentStep + 1
    }
  }

  public setPreviousStep() {
    if (this.currentStep === 0) {
      this.currentStep = this.wizardStepDefinitions.length - 1
    } else {
      this.currentStep = this.currentStep - 1
    }
  }
  //#endregion
}
</script>

<style scoped>
.rectangle-wizard {
  width: 320px;
  background-color: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(12, 0, 51, 0.1);
  margin-left: 20px;
  padding-top: 25px;
  display: inline-block;
  vertical-align: top;
  padding-bottom: 25px;
}

.rectangle-wizard-container--flex {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
}

.rectangle-wizard-image {
  height: 52px;
  width: 76.3px;
  display: block;
  margin: 0 auto;
}

.rectangle-wizard-step-label {
  color: #88949b;
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
}

.rectangle-wizard-text {
  color: #1a262f;
  font-family: 'Open Sans';
  font-size: 15px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  margin: 0 20px;
}
.rectangle-wizard-paging {
  margin-top: 16px;
  text-align: center;
  z-index: 0;
}
.rectangle-wizard-paging-number {
  position: absolute;
  display: inline-block;
  border-radius: 15px;
  color: #ffffff;
  background-color: #34b4e4;
  height: 30px;
  width: 30px;
  font-family: 'Open Sans';
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
  padding: 4px;
}
.rectangle-wizard-dot {
  display: inline-block;
  margin-left: 15px;
  margin-top: 10px;
  border-radius: 10px;
  height: 7px;
  width: 6.86px;
  background-color: #e0e0e0;
}
</style>
